import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { PricingService } from './pricing.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
  constructor(
    protected readonly baseService: BaseService,
    protected readonly pricingService: PricingService) {
  }

  protected tariffs: any[] = [];

  ngOnInit(): void {
    this.pricingService.getTariffs()
      .subscribe((res) => {
        this.tariffs = res;
      });
  }


  protected readonly environment = environment;
}
